import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEditResidencePage = {
  alert: {
    error: 'coapplicant-edit-residence-page.alert.error',
  },
  footer: {
    root: 'coapplicant-edit-residence-page.footer.root',
  },
  form: {
    addressLine1Input:
      'coapplicant-edit-residence-page.form.address-line-1-input',
    addressLine1InputError:
      'coapplicant-edit-residence-page.form.address-line-1-input-error',
    addressLine2Input:
      'coapplicant-edit-residence-page.form.address-line-2-input',
    amountInput: 'coapplicant-edit-residence-page.form.amount-input',
    amountInputError: 'coapplicant-edit-residence-page.form.amount-input-error',
    cancelButton: 'coapplicant-edit-residence-page.form.cancel-button',
    cityInput: 'coapplicant-edit-residence-page.form.city-input',
    cityInputError: 'coapplicant-edit-residence-page.form.city-input-error',
    h1: 'coapplicant-edit-residence-page.form.h1',
    h2: 'coapplicant-edit-residence-page.form.h2',
    monthSelect: 'coapplicant-edit-residence-page.form.month-select',
    monthSelectError: 'coapplicant-edit-residence-page.form.month-select-error',
    previousAddressLine1Input:
      'coapplicant-edit-residence-page.form.previous-address-line-1-input',
    previousAddressLine1InputError:
      'coapplicant-edit-residence-page.form.previous-address-line-1-input-error',
    previousAddressLine2Input:
      'coapplicant-edit-residence-page.form.previous-address-line-2-input',
    previousCityInput:
      'coapplicant-edit-residence-page.form.previous-city-input',
    previousCityInputError:
      'coapplicant-edit-residence-page.form.previous-city-input-error',
    previousResidenceRoot:
      'coapplicant-edit-residence-page.form.previous-residence-root',
    previousStateSelect:
      'coapplicant-edit-residence-page.form.previous-state-select',
    previousStateSelectError:
      'coapplicant-edit-residence-page.form.previous-state-select-error',
    previousZipCodeInput:
      'coapplicant-edit-residence-page.form.previous-zip-code-input',
    previousZipCodeInputError:
      'coapplicant-edit-residence-page.form.previous-zip-code-input-error',
    residenceTypeSelect:
      'coapplicant-edit-residence-page.form.residence-type-select',
    residenceTypeSelectError:
      'coapplicant-edit-residence-page.form.residence-type-select-error',
    root: 'coapplicant-edit-residence-page.form.root',
    stateSelect: 'coapplicant-edit-residence-page.form.state-select',
    stateSelectError: 'coapplicant-edit-residence-page.form.state-select-error',
    submitButton: 'coapplicant-edit-residence-page.form.submit-button',
    zipCodeInput: 'coapplicant-edit-residence-page.form.zip-code-input',
    zipCodeInputError:
      'coapplicant-edit-residence-page.form.zip-code-input-error',
  },
  header: {
    drawerButton: 'coapplicant-edit-residence-page.header.drawer-button',
    previousStepButton:
      'coapplicant-edit-residence-page.header.previous-step-button',
    root: 'coapplicant-edit-residence-page.header.root',
  },
  progress: {
    root: 'coapplicant-edit-residence-page.progress.root',
  },
} as const satisfies PageLocatorMap;
